import React from 'react'
import { Modal, Space, Typography } from 'antd-v4'
import { ExportProductButton } from './ExportProductButton'
import { InfoCircleFilled } from '@ant-design/icons'
import { COLORS } from '../../../../constants/Colors'

interface IProps {
  visible: boolean
  onCancel: () => void
}

export const ExportProductsWarningModal: React.FC<IProps> = ({ visible, onCancel }) => (
  <Modal
    visible={visible}
    onCancel={onCancel}
    footer={<ExportProductButton />}
    zIndex={1001}
    width={320}
  >
    <Typography.Paragraph style={{ textAlign: 'center', margin: '32px 0 0' }}>
      <InfoCircleFilled style={{ color: COLORS.warningIcon, marginRight: '8px' }} />
      Please make sure to keep a copy of your current product details
    </Typography.Paragraph>
  </Modal>
)
